var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileWorkplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 36,
    viewBox: "0 0 18 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 32.9999C0.666748 34.3806 1.78604 35.4999 3.16675 35.4999H14.8334C16.2141 35.4999 17.3334 34.3806 17.3334 32.9999V13.8333H0.666748V32.9999ZM10.6667 34.6666H7.33342V31.7499C7.33342 30.8294 8.07961 30.0833 9.00008 30.0833C9.92056 30.0833 10.6667 30.8294 10.6667 31.7499V34.6666ZM1.50008 14.6666H16.5001V32.9999C16.5001 33.9204 15.7539 34.6666 14.8334 34.6666H11.5001V31.7499C11.5001 30.3692 10.3808 29.2499 9.00008 29.2499C7.61937 29.2499 6.50008 30.3692 6.50008 31.7499V34.6666H3.16675C2.24627 34.6666 1.50008 33.9204 1.50008 32.9999V14.6666ZM7.75008 18.8333H4.00008V17.9999H7.75008V18.8333ZM7.75008 22.5833H4.00008V21.7499H7.75008V22.5833ZM7.75008 26.3333H4.00008V25.4999H7.75008V26.3333ZM14.0001 18.8333H10.2501V17.9999H14.0001V18.8333ZM14.0001 22.5833H10.2501V21.7499H14.0001V22.5833ZM14.0001 26.3333H10.2501V25.4999H14.0001V26.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19175 4.99164L0.604248 4.39998C5.25244 -0.244979 12.7852 -0.244979 17.4334 4.39998L16.8459 4.99164C12.5228 0.669785 5.51491 0.669785 1.19175 4.99164ZM14.7834 7.05414C11.5993 3.87145 6.43835 3.87145 3.25425 7.05414L3.84592 7.64164C6.70308 4.7853 11.3346 4.7853 14.1917 7.64164L14.7834 7.05414ZM5.89592 9.69581L6.50008 10.2833C7.17151 9.61057 8.08295 9.23251 9.03342 9.23251C9.98389 9.23251 10.8953 9.61057 11.5667 10.2833L12.1584 9.69164C11.33 8.86217 10.2057 8.39609 9.03342 8.39609C7.86109 8.39609 6.73686 8.86217 5.90842 9.69164L5.89592 9.69581Z",
    fill: "url(#paint0_linear_1256_9521)",
    fillOpacity: 0.93
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1256_9521",
    x1: 0.604248,
    y1: 5.59978,
    x2: 17.4334,
    y2: 5.59978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWorkplace);
export default __webpack_public_path__ + "static/media/mobile-workplace.bbf31a5780ae11c90468cb75a44e5c33.svg";
export { ForwardRef as ReactComponent };